import React from "react";

import {
    PackageSearch,
    RefreshCw,
    Bike,
    Clock3,
    CheckCircle2,
    XCircle
} from "lucide-react";

import "./EmptyOrders.css";

function EmptyOrders({

    status,

    refresh,

}) {

    const getData = () => {

        switch(status){

            case "pending":

                return{

                    title:"No Pending Orders",

                    message:"You're all caught up. Stay online to receive new delivery requests.",

                    icon:<Clock3 size={72}/>

                };

            case "active":

                return{

                    title:"No Active Deliveries",

                    message:"You don't have any active deliveries at the moment.",

                    icon:<Bike size={72}/>

                };

            case "completed":

                return{

                    title:"No Completed Orders",

                    message:"Your completed deliveries will appear here once you finish an order.",

                    icon:<CheckCircle2 size={72}/>

                };

            case "cancelled":

                return{

                    title:"No Cancelled Orders",

                    message:"Great! You don't have any cancelled deliveries.",

                    icon:<XCircle size={72}/>

                };

            default:

                return{

                    title:"No Orders Found",

                    message:"There are no orders available at the moment.",

                    icon:<PackageSearch size={72}/>

                };

        }

    };

    const data = getData();

    return(

        <div className="hf-empty-orders">

            <div className="hf-empty-card">

                <div className="hf-empty-icon">

                    {data.icon}

                </div>

                <h2>

                    {data.title}

                </h2>

                <p>

                    {data.message}

                </p>

                

            </div>

        </div>

    );

}

export default EmptyOrders;